module.exports = __webpack_public_path__ + "img/one.aa8cc442.png";